import { DataCard } from '../../../components/DashboardCard';
import { useSignageAnalytics } from '../../../hooks/Dashboard/useSignageAnalytics';

export const SignageCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { signageAnalytics, getSignageAnalytics, loading } =
    useSignageAnalytics();
  return (
    <DataCard
      data={signageAnalytics}
      title="Signage"
      views={['basic']}
      refresh={true}
      loading={loading}
      onRefresh={getSignageAnalytics}
      theme={theme}
    />
  );
};
